var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15H2.5C1.12 15 0 13.88 0 12.5V3.5C0 2.12 1.12 1 2.5 1H11.5C12.88 1 14 2.12 14 3.5V12.5C14 13.88 12.88 15 11.5 15Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5V11.5C14 12.88 12.88 14 11.5 14H2.5C1.12 14 0 12.88 0 11.5V3.5C0 2.12 1.12 1 2.5 1H11.5C12.88 1 14 2.12 14 3.5Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5H0V3.5C0 2.12 1.12 1 2.5 1H11.5C12.88 1 14 2.12 14 3.5V5Z",
    fill: "#EF5350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C2.725 3 2.5 2.775 2.5 2.5V0.5C2.5 0.225 2.725 0 3 0C3.275 0 3.5 0.225 3.5 0.5V2.5C3.5 2.775 3.275 3 3 3Z",
    fill: "#FFCA28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3C10.725 3 10.5 2.775 10.5 2.5V0.5C10.5 0.225 10.725 0 11 0C11.275 0 11.5 0.225 11.5 0.5V2.5C11.5 2.775 11.275 3 11 3Z",
    fill: "#FFCA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlank);
export default __webpack_public_path__ + "static/media/calendar_blank.13eb131b863582a0a37a160fba77ece3.svg";
export { ForwardRef as ReactComponent };